import React from 'react';

/**
 * Reusable org block (sidebar info block).
 */
const OrgBlock = ({ title, subtitle, children, className = '' }) => {
  return (
    <div className={`org-block ${className}`}>
      {title && <div className="org-block__title">{title}</div>}
      {subtitle && <div className="org-block__subtitle">{subtitle}</div>}
      {children}
    </div>
  );
};

export default OrgBlock;
